// Copyright (C) 2021 TANNER AG

const routes = {
    eMobility: "/e-mobility",
    transportSolutions: "/transport-solutions",
};

export default routes;



// WEBPACK FOOTER //
// ./src/emobility/routes.js